import React from 'react'
import styled from 'styled-components'

import { DeviceMaintenanceTrendGroup, DeviceMetric } from 'types/DeviceMetric'

type Props = {
  hideRanges: boolean
  metricAndGroupList: Array<DeviceMaintenanceTrendGroup | DeviceMetric>
}

const isMetric = (item: DeviceMaintenanceTrendGroup | DeviceMetric): item is DeviceMetric => {
  return (item as DeviceMetric).metricId !== undefined
}

const TrendMetricsOverview = ({ hideRanges, metricAndGroupList }: Props) => {
  return (
    <S.MetricsInfo>
      {metricAndGroupList.map((item) => {
        let range = ''
        if (isMetric(item)) {
          if (item.chart) {
            range = `${parseFloat(item.chart.lowGreen)} to ${parseFloat(item.chart.highGreen)}`
          }
        } else {
          range = item.range
        }

        return (
          <S.Metric key={item.name} >
            <S.InfoContent row={0}>
              <h5>Description:</h5>

              {item.description
                ? item.description.split(/\n/).map(value => <p key={value}>{value}</p>)
                : <p>--</p>
              }
            </S.InfoContent>

            {!hideRanges && range !== '' &&
              <S.InfoContent row={1}>
                <h5>Recommended Range:</h5>
                <S.Range>{range}</S.Range>
              </S.InfoContent>
            }

            {item.callToAction && item.callToAction.length > 0 &&
              <S.InfoContent row={2}>
                <h5>Call to Action:</h5>

                <S.List itemsCount={item.callToAction?.length ?? 0}>
                  {
                    item.callToAction.map(({ description, details }) =>
                      (
                        <div key={description}>
                          <li>{description}</li>
                          {details && <S.DetailsList> {details.map(detail => <li key={detail}>{detail}</li>)}</S.DetailsList>}
                        </div>
                      )
                    )
                  }
                </S.List>
              </S.InfoContent>
            }
          </S.Metric>
        )
      })
      }
    </S.MetricsInfo>
  )
}

export default TrendMetricsOverview

const S = {
  MetricsInfo: styled.div`
    display: grid;
    margin: auto 35px;
    grid-template-columns: repeat(auto-fit, minmax(50px, 1fr));
    grid-column-gap: 30px;
  `,
  Metric: styled.div`
    display: grid;
    grid-template-rows: 1fr  auto 2fr;
    grid-row-gap: 15px;
  `,
  InfoContent: styled.div.withConfig({
    shouldForwardProp: (prop) => !['row'].includes(prop)
  }) <{ row: number }>`
    padding: 10px 0px 0px 0px;

    & > h5 {
      text-transform: capitalize;
      margin: 0;
    }

    & > p {
      margin: 0;
      padding-top: 10px;
    }
  `,
  Range: styled.p`
    padding-top: 10px;
  `,
  List: styled.ul.withConfig({
    shouldForwardProp: (prop) => !['itemsCount'].includes(prop)
  }) <{ itemsCount: number }>`
    list-style-type: ${({ itemsCount }) => itemsCount > 1 ? 'disc' : 'none'};
    list-style-position: inside;
    padding-bottom: 10px;
    padding-left: 10px;
    margin: 0;
  `,
  DetailsList: styled.ul`
    list-style-position: inside;
    padding-left: 10px;
  `
}
